import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-seleccionar-carga-dialog',
  templateUrl: './seleccionar-carga-dialog.component.html',
  styleUrl: './seleccionar-carga-dialog.component.scss'
})
export class SeleccionarCargaModalComponent {
  constructor(
    public dialogRef: MatDialogRef<SeleccionarCargaModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  confirmarSalida(opc): void {
    this.dialogRef.close({opcion: opc}); // Usuario acepta salir
  }

  cancelar(): void {
    this.dialogRef.close(false); // Usuario cancela
  }
}